import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestUserUpdate = (data) =>
  axios.put(`${apiUrl}user`, data);

export const requestExport = (filters) => axios.post(`${apiUrl}user/export`, {
  criteria: filters
}, {
  contentType: "application/json;charset=utf-8",
  responseType: "blob",
});

export const requestSendNotification = (data) => axios.post(`${apiUrl}user/notify`, data);

export const requestUserPackage = (userId, packageId) =>
  axios.patch(`${apiUrl}sharing/account/${userId}/package/${packageId}/activate`);

export const requestUserTariff = (userId, tariffId, until) =>
  axios.patch(`${apiUrl}sharing/account/${userId}/tariff/${tariffId}/activate/${until}`);

export const requestAddBonus = (payload) => axios.post(`${apiUrl}wallet/deposit`, payload);



// WEBPACK FOOTER //
// ./src/actions/users/requests.js